import { render } from "./TabFunds.vue?vue&type=template&id=7f3f06f4"
import script from "./TabFunds.vue?vue&type=script&lang=js"
export * from "./TabFunds.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__